import {
  SearchPanelColumn,
  SearchPanelColumnVariant,
  SearchPanelSkeletonFeature,
  SearchPanelSkeletonGrid,
  SearchPanelSkeletonRows,
} from '@vs-shop/commerce-ui/searchPanel';

/**
 * Loading placeholders for the header search popover. Pure presentational (no
 * hooks), so this module carries no `'use client'` directive and renders in
 * whichever environment imports it: the client suggest view while its request is
 * in flight, and `Search` itself for the keystrokes before the debounce has a
 * query to send.
 *
 * The arrangement mirrors rcprofi's own default panel so the popover holds its
 * size and shows motion instead of collapsing to the close button. Which
 * columns there are, and how many rows each stands in for, is this shop's; the
 * shapes are `@vs-shop/commerce-ui/searchPanel`.
 */
export function SearchSuggestSkeleton() {
  return (
    <>
      <SearchPanelColumn variant={SearchPanelColumnVariant.AIRY} className="lap:col-span-1">
        <SearchPanelSkeletonRows rows={3} />
        <SearchPanelSkeletonRows rows={3} />
        <SearchPanelSkeletonRows rows={2} />
      </SearchPanelColumn>

      <SearchPanelColumn variant={SearchPanelColumnVariant.FLUSH} className="lap:col-span-1">
        <SearchPanelSkeletonFeature />
      </SearchPanelColumn>

      <SearchPanelColumn variant={SearchPanelColumnVariant.FLUSH} className="lap:col-span-2">
        <SearchPanelSkeletonGrid cells={4} />
      </SearchPanelColumn>
    </>
  );
}
